import React from 'react';

interface InputCharacterCountProps {
  currentLength: number;
  maxLength: number;
  showAlways?: boolean;
  className?: string;
}

/**
 * Component to display character count for input fields
 * Shows warning when approaching limit and error when exceeding
 */
const InputCharacterCount: React.FC<InputCharacterCountProps> = ({
  currentLength,
  maxLength,
  showAlways = false,
  className = '',
}) => {
  // Calculate percentage of max length used
  const percentUsed = (currentLength / maxLength) * 100;
  
  // Determine if we should show the counter
  // Always show if showAlways is true, or if we're at 70% capacity or more
  const shouldShow = showAlways || percentUsed >= 70;
  
  if (!shouldShow) {
    return null;
  }
  
  // Determine color based on percentage used
  let textColorClass = 'text-gray-400 dark:text-gray-500';
  
  if (percentUsed >= 100) {
    textColorClass = 'text-red-500 dark:text-red-400';
  } else if (percentUsed >= 90) {
    textColorClass = 'text-amber-500 dark:text-amber-400';
  }
  
  return (
    <div className={`text-xs mt-1 text-right ${textColorClass} ${className}`}>
      <span className="font-mono">{currentLength}</span>
      <span className="mx-1">/</span>
      <span className="font-mono">{maxLength}</span>
      {percentUsed >= 100 && <span className="ml-2">Character limit reached</span>}
    </div>
  );
};

export default InputCharacterCount;
